export default {
  path: '/adminManage',
  name: 'adminManage',
  component: () => import('../views/layouts/AdminManage.layout.vue'),
  meta: {
    // eslint-disable-next-line prettier/prettier
    requiresAuth: true
  },
  children: [
    {
      path: 'indexAdmin',
      name: 'adminManageIndex',
      component: () =>
        import('../views/pages/adminManage/adminManageIndex.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'managelist',
      name: 'managelist',
      component: () => import('../views/pages/adminManage/ManageList.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'search',
      name: 'search',
      component: () => import('../views/pages/adminManage/searchUser.page.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
}
